import * as React from 'react';

import { NuorderOrderingActionTypes } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';

export const useClearViewTabs = (lastAction: NuorderOrderingActionTypes | null) => {
  const [viewTabsCleared, setViewTabsCleared] = React.useState<boolean>(false);

  const actionsToClearTabs = React.useMemo(
    () =>
      [
        NuorderOrderingActionTypes.UPDATE_PURCHASE,
        NuorderOrderingActionTypes.UPDATE_PURCHASE_LINE,
        NuorderOrderingActionTypes.DELETE_PURCHASE_LINE,
        NuorderOrderingActionTypes.UPDATE_ITEM_VENDOR_NUM,
        NuorderOrderingActionTypes.DELETE_ITEM_VENDOR_NUM,
      ] as NuorderOrderingActionTypes[],
    []
  );

  React.useEffect(() => {
    if (!window.clearViewTabs) {
      setViewTabsCleared(true);
      return;
    }
    if (viewTabsCleared) return;
    if (!lastAction) return;
    if (!actionsToClearTabs.includes(lastAction)) return;
    window.clearViewTabs();
    setViewTabsCleared(true);
  }, [actionsToClearTabs, lastAction, viewTabsCleared]);

  return { viewTabsCleared, setViewTabsCleared };
};
